import {
    REQUEST_SETTINGSMESSAGES,
    RECEIVE_SETTINGSMESSAGES,
    ERROR_SETTINGSMESSAGES
} from '../types'
import {initialFetchState} from "../../constants/defaultValues"
import _get from "lodash/get"
import _cloneDeep from 'lodash/cloneDeep'
import {loadDataRefresh} from "../../constants/constants";

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_SETTINGSMESSAGES:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_SETTINGSMESSAGES:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.short + Date.now(),
                message: '',
            }
        case ERROR_SETTINGSMESSAGES:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}